import { render, staticRenderFns } from "./pagination_v4.vue?vue&type=template&id=e9f88d80&scoped=true"
import script from "./pagination_v4.vue?vue&type=script&lang=js"
export * from "./pagination_v4.vue?vue&type=script&lang=js"
import style0 from "./pagination_v4.vue?vue&type=style&index=0&id=e9f88d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f88d80",
  null
  
)

export default component.exports